import { Link } from 'react-router-dom';

import classes from './VendorList.module.css';

import LogoImage from './LogoImage.jsx';

function VendorList({vendors}) {

  return (
    <div className={classes.vendors}>
      <ul className={classes.list}>
        {vendors.map((vendor) => (
          <li key={vendor.id} className={classes.item}>
            <Link to={`/vendors/${vendor.id}`}>
              <LogoImage
                title={vendor.title}
                logo_contents={vendor.logo_contents}
                logo_filetype={vendor.logo_filetype}
              />
              <ul className={classes.list}>
              <li>
              <h2>{vendor.title}</h2>
              </li>
              </ul>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default VendorList;
